module.exports = __webpack_public_path__ + "img/sala2.5c2628f5.jpg";